<template>
  <div class="container">
    <div class="row justify-content-around">
      <div class="col-12 col-md-4">
        <form class="form-signin" @submit="submitLoginForm">
          <h1 class="form-signin-heading">Faça login</h1>
          <b-input
            placeholder="Email cadastrado"
            class="form-control"
            type="email"
            id="textEmail"
            v-model="userLogin.email"
            required
          />
          <b-input
            placeholder="Sua senha"
            class="form-control"
            type="password"
            id="textPassword"
            v-model="userLogin.password"
            required
          />

          <b-button block size="lg" type="submit" variant="primary">Entrar</b-button>
        </form>

        <div class="register-box">
          <p class="lead">não lembra sua senha?</p>

          <!-- <b-modal
            id="registerModal"
            ref="registerModal"
            header-bg-variant="dark"
            :hide-footer="true"
            :hide-header="true"
            size="md"
            body-class="modal-register"
          >
            <b-container fluid>
              <form class="form-signin" @submit="submitSignupForm">
                <h1 class="form-heading">Vamos começar?</h1>
                <b-input
                  placeholder="Qual o seu email?"
                  class="form-control"
                  type="email"
                  id="textEmail"
                  v-model="userSignup.email"
                  required
                />

                <b-button block size="lg" type="submit" variant="primary">Próximo</b-button>
              </form>
            </b-container>
          </b-modal>

          <b-btn class="btn btn-block btn-lg btn-dark" v-b-modal.registerModal>
            <i class="fab fa-steam"></i>
            Cadastre-se
          </b-btn>
          -->
          <a
            class="btn btn-block btn-lg btn-dark"
            :href="`${isLocal ? 'https://api.queota.club' : 'http://localhost:5000'}/auth/steam`"
          >
            <i class="fab fa-steam"></i>
            Entre agora com sua Steam
          </a>
        </div>
      </div>

      <div class="col-12 col-md-8">
        <div class="extra-content">
          
          <!-- <div class="section join-us">
            <h3>
              junte-se a essa galera que joga aqui
              <small>(e muitos mais...)</small>
            </h3>
            <div class="members-list">
              <div class="member" v-for="user in latestUsers" :key="user.slug">
                <router-link
                  :to="{ name: 'UserSingle', params: { id: user.to_param }}"
                  class="user-card"
                  v-b-tooltip.hover
                  :title="user.nickname"
                >
                  <div class="user-image">
                    <b-img :src="user.avatar.url" :alt="user.nickname"/>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="numbers-section">
            <div class="row justify-content-center">
              <div class="col-2">
                <h4>6300+</h4>
                <p class>usuários</p>
              </div>
              <div class="col-2">
                <h4>520+</h4>
                <p class>times</p>
              </div>
              <div class="col-2">
                <h4>2100+</h4>
                <p class>partidas</p>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "Login",
  metaInfo: {
    title: "Fazer login"
  },
  data() {
    return {
      userLogin: { email: "", password: "" },
      latestUsers: [],
      userSignup: { email: "" }
    };
  },
  computed: {
    isLocal: function() {
      return window.location.hostname == "queota.club";
    }
  },
  methods: {
    initialize() {
      // this.$http
      //   .get('wall_of_shame.json')
      //   .then(response => (this.users = response.data.users))
      this.$http
        .get("latest_users.json")
        .then(response => (this.latestUsers = response.data.users));
    },
    submitSignupForm(evt) {
      evt.preventDefault();
      var self = this;
      this.$http
        .post("register.json", { email: this.userSignup.email })
        .then(response => {
          if (response.data && response.data.message) {
            alert(response.data.message);
          } else if (response.data && response.data.token) {
            localStorage.setItem("token", response.data.token);
            self.$store
              .dispatch("login", response.data.token)
              .then(() => self.$router.push("/"));
          }
        });
    },
    submitLoginForm(evt) {
      var self = this;
      evt.preventDefault();
      this.$http.post("login.json", { user: this.userLogin }).then(response => {
        if (response.data.token) {
          localStorage.setItem("token", response.data.token);
          self.$store
            .dispatch("login", response.data.token)
            .then(() => {
              if(self.$route.query.returnUrl && self.$route.query.returnUrl.indexOf('login') == -1)
                self.$router.push(self.$route.query.returnUrl);
              else
                self.$router.push("/");
            });

          if (
            window.jivo_api &&
            self.$store.getters.isLoggedIn &&
            self.$store.getters.currentUser
          ) {
            window.jivo_api.setContactInfo({
              "name": self.$store.getters.currentUser.nickname,
              "email": self.$store.getters.currentUser.email,
              "description": `https://queota.club/users/${self.$store.getters.currentUser.id}`
            });
          }
        }
      });
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    Header
  }
};
</script>

<style lang="sass">
body.login-page
  // background: #efefef

  .register-box
    max-width: 340px
    margin: 40px auto 10px
    padding-top: 30px
    border-top: 1px solid #ccc

  .form-signin
    max-width: 340px
    margin: 60px auto 10px

    .form-signin-heading
      font-weight: bold
      color: #fff
      margin-bottom: 10px

    .checkbox
      font-weight: normal

    .form-control
      position: relative
      font-size: 16px
      height: auto
      padding: 10px
      // @include box-sizing(border-box)

    input[type="email"]
      margin-bottom: -1px
      border-top: 1px solid transparent
      border-right: 1px solid transparent
      border-left: 1px solid transparent
      box-shadow: none
      border-radius: 3px 3px 0px 0px
      &:focus
        box-shadow: inset 0 1px 1px rgba(0,0,0,0.075)

    input[type="password"]
      z-index: 2
      margin-bottom: 20px
      border-top: none
      border-bottom: 1px solid transparent
      border-right: 1px solid transparent
      border-left: 1px solid transparent
      border-radius: 0px 0px 3px 3px
      box-shadow: inset 0 1px 1px rgba(0,0,0,0.075)
      &:focus
        box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0px 1px 0px 0px rgba(255,255,255,0.5)

  .btn
    border-radius: 3px
    border: none
    font-weight: bold
    .btn-dark
      $bluer: #2B59C3
      background: darken($bluer, 0%)

    &.btn-dark
      padding: 14px 18px
    i.fab
      font-weight: normal

  .extra-content
    padding: 40px 0

  .join-us
    margin: 40px 0 20px
    h3
      text-align: center
      margin: 20px 0
      font-size: 14px
      text-transform: lowercase
      font-family: inherit
      font-weight: normal

    .members-list
      display: flex
      flex-wrap: wrap
      // justify-content: space-between
      a
        position: relative
        cursor: pointer
        img
          width: 32px
          height: 32px
          border-radius: 100%
          opacity: .15
          transition: all .1s
          cursor: pointer
        &:hover
          img
            opacity: 1
            transform: scale(1.1)

  .section:not(.numbers):not(.join-us)
    margin: 20px 0
    padding: 10px 0
    h2
      text-align: center
  .numbers-section
    text-align: center
    h4
      margin: 0
    p
      margin: 0
</style>
